export const pollsCmsHelperText = "Polls to be featured in Coa's mobile app and beyond.";
